require(['requireConfig'], function () {
    'use strict';

    require(['main']);
});

define("app", function(){});
